export class ShippingStorage {
    private static readonly AUTO_POPUP_KEY = "wop_so_shipping_auto_popup";

    static loadAutoPopupState(): boolean {
        const savedState = localStorage.getItem(this.AUTO_POPUP_KEY);
        return savedState === "true";
    }

    static saveAutoPopupState(isChecked: boolean): void {
        localStorage.setItem(this.AUTO_POPUP_KEY, isChecked.toString());
    }

    static getAutoPopupState(): boolean {
        return this.loadAutoPopupState();
    }
}

